import { prefix as prefixBase } from '../../constants'
export const prefixTable = `${prefixBase}.table`
export const prefixColumns = `${prefixTable}.columns`

export enum ParticipantsColumns {
  name = 'full_name',
  area = 'area_name',
  lmsProfiles = 'lms_profiles_name',
  lmsProfilesId = 'lms_profiles_id',
  coursesCount = 'all_courses_count',
  coursesAdvance = 'all_courses_advance_finish',
  evaluationsApproved = 'all_course_progress_evaluations_approved',
  lmsActive = 'user_lms_active_and_user_active',
  action = 'action',
}
